import { Button } from "@/components/ui/button";
import { useState } from "react";
import { SharingProfileModal } from "./SharingProfileModal";
import { Share } from "lucide-react";

export function SharingProfileButton({ userId }: { userId: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        className="w-full gap-2 font-semibold sm:w-auto"
        onClick={() => setOpen(true)}
      >
        <Share aria-hidden="true" className="size-4" />
        Share Profile
      </Button>
      <SharingProfileModal
        open={open}
        onOpenChange={setOpen}
        userId={userId}
        appearance="profile"
      />
    </>
  );
}
